(() => {
  const selector = 'slideshow-component[data-funlab-banner-carousel]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const globalListenerKey = '__funlabBannerCarouselListenersReady';

  function pauseForPreference(carousel) {
    const slider = carousel.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const hasMultipleSlides = carousel.querySelectorAll('.funlab-banner-carousel__slide').length > 1;
    const configuredAutoplay = carousel.dataset.configuredAutoplay === 'true' && hasMultipleSlides;

    if (reducedMotion.matches) {
      slider.dataset.autoplay = 'false';
      if (typeof carousel.pause === 'function') carousel.pause();
      return;
    }

    slider.dataset.autoplay = configuredAutoplay ? 'true' : 'false';
    if (
      configuredAutoplay &&
      typeof carousel.play === 'function' &&
      !document.hidden &&
      !carousel.matches(':hover') &&
      !carousel.contains(document.activeElement)
    ) {
      carousel.play();
    }
  }

  function initialize(scope = document) {
    scope.querySelectorAll(selector).forEach((carousel) => {
      if (carousel.dataset.funlabReady === 'true') {
        pauseForPreference(carousel);
        return;
      }

      carousel.dataset.funlabReady = 'true';
      pauseForPreference(carousel);

      const autoplayButton = carousel.querySelector('.slideshow__autoplay');
      if (autoplayButton) {
        autoplayButton.addEventListener('click', () => {
          if (reducedMotion.matches && typeof carousel.pause === 'function') carousel.pause();
        });
      }
    });
  }

  function onVisibilityChange() {
    document.querySelectorAll(selector).forEach((carousel) => {
      if (document.hidden) {
        if (typeof carousel.pause === 'function') carousel.pause();
      } else {
        pauseForPreference(carousel);
      }
    });
  }

  if (window[globalListenerKey]) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    return;
  }

  window[globalListenerKey] = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  reducedMotion.addEventListener('change', () => initialize());
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest(selector);
    if (carousel && typeof carousel.pause === 'function') carousel.pause();
  });
})();
